import React from "react";
import { ShowGenre } from "pages";

const ShowGenreRoute = () => {
  return (
    <>
      <ShowGenre />
    </>
  );
};

export default ShowGenreRoute;
